
import Vue from 'vue'
import AppMixin from '@/_mixins/app'
import { moduleStatuses, initPostModule, initPatchModule } from '@/utils/project'
const ModuleSettings = Vue.extend({
    mixins: [AppMixin],
    components: {},
    props: {
        moduleId: {
            required: true,
            type: String,
        },
        project: {
            required: true,
            type: Object,
        },
    },

    data() {
        return {
            status: null as string | null,
            loadingStatus: false,
        }
    },

    computed: {
        moduleStatuses() {
            const statuses = moduleStatuses.map((item) => {
                return {
                    value: item,
                    text: this.$t(`project_enums['projectModule.status.${item}']`),
                    disabled: this.projectModule
                        ? this.projectModule.constraints.status.whitelist.findIndex(
                              (val) => val == item
                          ) == -1
                        : false,
                }
            })

            return this.status && this.status == 'deleted'
                ? statuses
                : statuses.filter((item) => item.value !== 'deleted')
        },
        projectModule() {
            return this.project.modules.data.find(
                (module) => module.module.data.id == this.moduleId
            )
        },

        disabled() {
            return this.isSuperuser
                ? false
                : !this.project?.permissions.includes(`project.manage.${this.moduleId}`)
        },
    },

    methods: {
        async initPost() {
            const res = await initPostModule(this.moduleId, this.project)
            this.$emit('updateProjectModules', res)
            this.setStatus()
        },

        async initPatch(status) {
            const res = await initPatchModule(this.project, this.projectModule, status)
            this.$emit('updateProjectModules', { projectModule: res, project: this.project })
            this.setStatus()
        },

        setStatus() {
            this.status = this.projectModule ? this.projectModule.status : null
        },
    },

    mounted() {
        this.setStatus()
    },
})

export default ModuleSettings
